import BaseLayout from '@/components/BaseLayout.vue'
import api from '@/services/api';
import router from "@/router";
import {mapActions, mapGetters} from "vuex";

export default {
    name: 'newPromotionHall',

    data(){
        return {
            promotionType: '',
            potentialTeamMates: [],
            teamMates: [],
            imageId: null,
            showLoader: false,
        };
    },

    components: {
        BaseLayout,
    },

    computed: {
        ...mapGetters({
            promotion: 'promotion/promotion',
        }),
    },

    methods: {
        ...mapActions('promotion', ['storePromotion']),
        /**
         * Remove coworker from this team
         * @param username
         */
        removeMate(username) {
            this.promotion.activePromotion.additional_promoters = this.promotion.activePromotion.additional_promoters.filter((mate) => {
                return mate.username !== username;
            })
        },

        /**
         * Add user to team mates
         *
         * @param id
         * @param username
         */
        addToTeamMates(id, username) {
            this.promotion.activePromotion.additional_promoters.push({id, username});
            this.potentialTeamMates = this.potentialTeamMates.filter((mate) => {
                return mate.username !== username;
            })
        },

        /**
         * Search new coworker from backend for this team
         * @param event
         */
        searchNewTeamMate(event) {
            if (event.target.value == '') {
                return;
            }
            const params = new URLSearchParams();
            params.append('username', event.target.value);
            api.post('/api/promoters_search', params)
                .then((response) => {
                    this.potentialTeamMates = response.data.body.entries;
                })
                .catch((error) => {
                    //commit('SHOW_LOGIN_ERRORS', error.response.data);
                });
        },

        /**
         * Set image in data object when user upload image
         * @param event
         */
        uploadImage(event) {
            this.showLoader = true;
            let formData = new FormData();
            formData.append('file', event.target.files[0])
            api.post('/api/assets', formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    this.imageId = response.data.body.entry.id;
                    this.showLoader = false;
                })
                .catch((error) => {
                    this.showLoader = false;
                });
        },

        /**
         * Clear search input
         */
        clearSearchTerm() {
            this.$refs['searchTerm'].value = '';
            this.potentialTeamMates = [];
        },

        /**
         * Send to server new created promotion
         */
        submitEditPromotion() {
            const params = new FormData();
            for(let promoter of this.promotion.activePromotion.additional_promoters){
                params.append('additional_promoters[]', promoter.id);
            }
            params.append('type', 2);
            if(this.imageId) {
                params.append('promotion_stand', this.imageId);
            }
            // TODO Proveri sta se desava ovde i with samples
            params.append('promotion_with_gifts', Number(this.promotionType) === 1 ? 1 : 0);

            api.post(`/api/promotions_edit`, params)
                .then(() => {
                    this.storePromotion();
                    router.replace('/promotion')
                })
                .catch((error) => {
                });
        },

        /**
         * Send user back
         */
        goBack() {
            router.replace('/promotion')
        },
    },

    watch: {
        'promotion.activePromotion.promotion_with_gifts': function (){
            this.promotionType = this.promotion.activePromotion.promotion_with_gifts;
        }
    },

    mounted() {
        this.storePromotion();
        this.promotionType = this.promotion.activePromotion.promotion_with_gifts;
    },
}